module.exports = __webpack_public_path__ + "img/248-russia.13902542.svg";